// TRANSITION
export const ACTION_TRANSITIONS_SET = "core/ACTION_TRANSITIONS_SET";
export const ACTION_TRANSITIONS_RESET = "core/ACTION_TRANSITIONS_RESET";
export const GETTER_TRANSITIONS_GET = "core/GETTER_TRANSITIONS_GET";
